


























































































import { Component, Vue, Prop, Provide, Emit, Watch } from 'vue-property-decorator'
import Velocity from 'velocity-animate'
import { throttle, debounce } from 'throttle-debounce'
import QRender from '@/components/qrender/QRender.vue'
import { questionDetail } from './../model/api'
import { singleQuestionDetail } from '../../analysis/model/api'

@Component({
  components: { QRender }
})
export default class QuestionBox extends Vue {
  private get shopStatus() {
    return this.data.inShoppingCart
  }
  private get analysisStatus() {
    return this.data.showAnalysis
  }
  private get user() {
    return this.$store.state.user
  }
  @Prop({
    default() {
      return true
    }
  })
  public haveAnalysis!: boolean
  @Prop() public data!: any
  @Prop() public content!: boolean
  @Prop() public position!: number | string
  @Prop() public changeAble!: boolean
  @Prop() public animate!: boolean
  @Prop({
    default() {
      return true
    }
  })
  public haveShopCart!: boolean
  @Prop({
    default() {
      return true
    }
  })
  public needLog!: boolean
  @Prop({
    default() {
      return 0
    }
  })
  public idx!: number | string
  @Prop({
    default() {
      return true
    }
  })
  public showTools!: boolean
  @Prop()
  public analysisDefault!: boolean
  @Prop()
  public showPreviewBtn!: boolean
  @Prop({
    default() {
      return true
    }
  })
  public showWaterMaker!: boolean
  @Prop() public showTitle!: boolean

  @Prop({
    default() {
      return false
    }
  })
  // 是否显示试卷名
  public showPaperName!: boolean

  public status = false
  public offsetTop = 0
  public showAnalysis = false
  public inShoppingCart = false
  private question: any = {} // question
  private ant = true
  private hover: boolean = false

  public beforeEnter(el) {}
  @Emit()
  public up() {}
  @Emit()
  public down() {}
  @Emit()
  public add(val) {
    return val
  }
  @Emit()
  public open(val) {
    return val
  }
  @Emit()
  public clickChange(val) {
    return val
  }
  @Watch('data', { deep: true, immediate: true })
  public onPropChange(val) {
    this.showAnalysis = false
    let temp = JSON.parse(JSON.stringify(val))
    this.question = temp
    if (this.haveAnalysis) {
      return
    }
    // console.log(this.question)
    if (this.analysisDefault) {
      if (val && val.id) {
        if (val.showAnalysis) {
          this.getQuestion(val)
        }
      }
    }
  }
  @Watch('content')
  public onContentChange(val) {}
  @Watch('shopStatus', { immediate: true })
  public onDataChange(val) {
    // console.log(val)
    this.inShoppingCart = val
  }

  public leave(el, done) {
    let that = this
    let result: string | number = 0
    let str = -this.offsetTop
    let clientRight = (this.$refs.question as any).getBoundingClientRect().right
    let clientleft = (this.$refs.question as any).getBoundingClientRect().left
    let right: number | string = ''
    let innerWidth = window.innerWidth
    let busTop: any = (document.getElementById('question-bus') as any).getBoundingClientRect().top
    if (clientRight < innerWidth) {
      right = innerWidth - clientRight + (clientRight - clientleft) / 2 - 55
    } else {
      right = 300
    }
    result = str + busTop
    console.log(right)
    Velocity(
      el,
      {
        translateY: result,
        translateX: right,
        scale: 0.1
      },
      { duration: 500, easing: 'easeInSine', complete: done }
    )
    setTimeout(() => {
      this.ant = true
    }, 500)
  }
  public enter(el, done) {
    Velocity(
      el,
      { translateY: 0, translateX: 0, scale: 1 },
      { duration: 0, easing: 'easeOut', complete: done }
    )
  }
  /**
   * changeStatus
   */
  public changeStatus(val: boolean) {
    this.status = val
  }
  public handleAnalysis(val) {
    if (!this.analysisDefault) {
      this.getQuestion(val)
    }
    this.open({ id: this.data.id, val })
  }
  public getQuestion(val) {
    if (this.needLog) {
      if (!this.user || !this.user.name) {
        this.$store.commit('SET_LOGINMODAL', true)
        return
      }
    }
    if (!this.haveAnalysis) {
      if (val) {
        this.showPaperName
          ? this.getPaperData({
              paper_id: this.data.paper_id,
              question_id: this.data.id
            })
          : this.getData({ question_id: this.data.id })
      }
    }
  }
  public addToCart(val) {
    this.ant = !val
    if (!this.user || !this.user.name) {
      this.$store.commit('SET_LOGINMODAL', true)
      return
    }
    if (!this.content) {
      this.inShoppingCart = val
    }
    let offsetTop = (this.$refs.question as any).getBoundingClientRect().top
    let offsetBottom = (this.$refs.question as any).getBoundingClientRect().bottom

    this.offsetTop = offsetTop + (offsetBottom - offsetTop) / 2
    this.add({
      id: this.data.id,
      val
    })
  }
  // 试卷分析新详情
  public async getPaperData(params) {
    let data: any = await singleQuestionDetail(params)
    if (data.success) {
      this.question = data.data
    } else {
      return
    }
  }
  public async getData(params) {
    let data = await questionDetail(params)
    if (data.success) {
      this.question = data.data
    } else {
      return
    }
  }
  public copyTextId() {
    let e: any = document.getElementById(this.question.text_id)
    let secondsToGo = 3

    e.select()
    document.execCommand('Copy') // 执行浏览器复制命令
    const modal = this.$success({
      title: `复制信息：${this.question.text_id}`,
      content: `复制成功， ${secondsToGo} 秒后关闭`,
      okText: '知道了'
    })
    const interval = setInterval(() => {
      secondsToGo -= 1
      modal.update({
        content: `复制成功， ${secondsToGo} 秒后关闭`
      })
    }, 1000)
    setTimeout(() => {
      clearInterval(interval)
      modal.destroy()
    }, secondsToGo * 1000)
  }
}
